import { render, staticRenderFns } from "./cluster-signatory-modal.vue?vue&type=template&id=208d5c78&"
import script from "./cluster-signatory-modal.vue?vue&type=script&lang=js&"
export * from "./cluster-signatory-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports